import { add, remove, qs, listen } from "@fluorescent/dom";
import srraf from "srraf";

export default function (container) {
  const classes = {
    hidden: "hidden",
  };

  const selectors = {
    buyButtons: ".product-form__item--submit",
    changeOptionButton: "[data-change-option-trigger]",
    pageFooter: "footer",
    stickyAtcBar: ".sticky-atc-bar",
    variantSelector: ".product__variants-wrapper",
  };

  const elements = {
    buyButtons: qs(selectors.buyButtons, container),
    pageFooter: qs(selectors.pageFooter, document),
    stickyAtcBar: qs(selectors.stickyAtcBar, container),
    variantSelector: qs(selectors.variantSelector, container),
  };

  if (elements.stickyAtcBar === null) return;

  const events = [];

  // Event delegation on the bar so the change-option-trigger keeps working
  // after a Section Rendering API swap replaces it (see Product#onOptionChange).
  events.push(
    listen(elements.stickyAtcBar, "click", event => {
      if (event.target.closest(selectors.changeOptionButton)) {
        scrollToVariantSelector();
      }
    })
  );

  let widthWatcher;

  const buyButtonsObserver = new IntersectionObserver(
    ([{ isIntersecting: visible }]) => {
      if (visible) {
        hideBar();
      } else {
        showBar();
      }
    }
  );

  const footerObserver = new IntersectionObserver(
    ([{ isIntersecting: visible }]) => {
      if (visible) {
        buyButtonsObserver.disconnect();
        hideBar();
      } else {
        buyButtonsObserver.observe(elements.buyButtons);
      }
    },
    { threshold: 0.8 }
  );

  footerObserver.observe(elements.pageFooter);

  const showBar = () => {
    remove(elements.stickyAtcBar, classes.hidden);
    setHeightVariable();

    widthWatcher = srraf(({ pvw, vw }) => {
      if (pvw !== vw) {
        setHeightVariable();
      }
    });
  };

  const hideBar = () => {
    add(elements.stickyAtcBar, classes.hidden);
    widthWatcher?.destroy();
    clearHeightVariable();
  };

  const setHeightVariable = () => {
    document.documentElement.style.setProperty(
      "--sticky-atc-bar-height",
      `${elements.stickyAtcBar.offsetHeight}px`
    );
  };

  const clearHeightVariable = () => {
    document.documentElement.style.setProperty(
      "--sticky-atc-bar-height",
      "0px"
    );
  };

  const scrollToVariantSelector = () => {
    elements.variantSelector.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
  };

  const unload = () => {
    buyButtonsObserver?.disconnect();
    events.forEach(unsubscribe => unsubscribe());
    footerObserver?.disconnect();
    widthWatcher?.destroy();
  };

  return { unload };
}
